import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Template } from '../../models/template';
import { TemplateFilter } from '../../models/template-filter';
import { BaseApiService } from '@core/http/base.api.service';
import { ConfigService } from '@core/services/config.service';
import { PageList } from '@core/models/page-list';
import { ClassroomCourse, ClassroomCourseFilter } from '@modules/course/classroom/models';
import { TemplatesSlotCount } from "@modules/template/student/models/templates-slot-count";
import { CourseRequest } from "@modules/template/student/models/course-request";



@Injectable({
  providedIn: 'root'
})
export class TemplateApiService extends BaseApiService {
  constructor(public http: HttpClient, private configService: ConfigService) {
    super(http);
  }

  get baseUrl(): string {
    const config = this.configService.getCurrent();
    return `${config.services.classroom}/api/template`;
  }

  get classroomBaseUrl(): string {
    const config = this.configService.getCurrent();
    return `${config.services.classroom}/api/classroom`;
  }

  get classroomCourseRequestBaseUrl(): string {
    const config = this.configService.getCurrent();
    return `${config.services.classroom}/api/courserequest`;
  }

  fetchTemplates(filter = new TemplateFilter()): Observable<PageList<Template>> {
    const params = new HttpParams()
      .append('search', filter.search)
      .append('templateType', filter.templateType)
      .append('onlyPublished', String(filter.onlyPublished))
      .append('onlyPending', String(filter.onlyPending));

    return super.getAllWithPagination<Template>(this.baseUrl, params);
  }

  fetchTemplate(id: string): Observable<Template> {
    return this.http.get<Template>(`${this.baseUrl}/${id}`);
  }

  fetchTemplatesSlotCount(): Observable<TemplatesSlotCount> {
    return this.http.get<TemplatesSlotCount>(`${this.classroomBaseUrl}/availableSlots`);
  }

  fetchTemplateClassroom(
    templateId: string,
    filter = new ClassroomCourseFilter()
  ): Observable<PageList<ClassroomCourse>> {
    const params = new HttpParams()
      .append('search', filter.search)
      .append('startDate', filter.fromDate)
      .append('endDate', filter.toDate)
      .append('regions', filter.locations.join(','))
      .append('onlyPublished', String(filter.onlyPublished))
      .append('onlyPending', String(filter.onlyPending))
      .append('onlyWithAvailableSlot', String(filter.onlyWithAvailableSlot))
      .append('templateId', templateId)
      .append('dateFilter', filter.dateFilter)
      .append('sort', filter.sort);

    return super.getAllWithPagination<ClassroomCourse>(this.classroomBaseUrl, params);
  }

  requestCourse(courseRequestBody: CourseRequest): Observable<any> {
    return this.http.post<any>(this.classroomCourseRequestBaseUrl,{...courseRequestBody})
  }
}
